import { riderSchema } from "../configs";
import { useCreateRiderMutation } from "../store";
import { showToast, ToastType } from "../utils/toast.utils";
import RiderForm from "../forms/Rider.form";

const CreateRider: React.FC = () => {
  const [createRider, { isLoading }] = useCreateRiderMutation();

  const initialValues = {
    email: "",
    password: "",
    firstName: "",
    lastName: "",
    phone: "",
    city: "",
    address: {
      street: "",
      city: "",
      zipCode: "",
      country: "",
    },
    transportType: "",
  };

  return (
    <div className="p-4 w-full">
      <RiderForm
        initialValues={initialValues}
        validationSchema={riderSchema}
        isLoading={isLoading}
        onSubmit={async (values, { resetForm }) => {
          const result = await createRider(values);
          if (!result.error) {
            showToast("Livreur créé avec succès", ToastType.SUCCESS);
            resetForm();
          }
        }}
      />
    </div>
  );
};

export default CreateRider;
